module.exports = __webpack_public_path__ + "static/media/ganesh.5c0dfa4e.jpg";